import { Box, BoxProps, Button, Chip, styled } from '@mui/material';

export const Container = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['isToolbar', 'isRightPositioned'].includes(prop)
})<BoxProps & { isToolbar?: boolean; isRightPositioned?: boolean }>(
  ({ theme, isToolbar, isRightPositioned }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.primary,
    justifyContent: 'center',
    height: '100%',
    padding: isToolbar && isRightPositioned ? 0 : theme.spacing(0, 3),
    position: 'relative',
    '.date-picker': {
      border: 'none'
    },

    button: {
      margin: theme.spacing(0, 1)
    }
  })
);

export const DateNavigationButton = styled(Button, {
  shouldForwardProp: (prop: string) =>
    ![
      'showIsToday',
      'showIsHoliday',
      'isToolbar',
      'isRightPositioned'
    ].includes(prop)
})<{
  showIsToday?: boolean;
  showIsHoliday?: boolean;
  isToolbar?: boolean;
  isRightPositioned?: boolean;
}>(({ theme, showIsToday, showIsHoliday, isToolbar, isRightPositioned }) => ({
  color: theme.palette.text.primary,
  backgroundColor: isToolbar ? 'none' : theme.vars.palette.secondary.container,
  padding:
    isToolbar && !isRightPositioned
      ? 0
      : isRightPositioned
      ? theme.spacing(1, 0)
      : theme.spacing(1.5, isToolbar ? 2.5 : 4.5),
  minWidth: isRightPositioned ? 0 : '64px',
  borderRadius: isToolbar ? 0 : theme.spacing(10),
  textTransform: 'none',
  lineHeight: 1.2,
  borderLeft:
    showIsToday || showIsHoliday
      ? `4px solid ${
          showIsToday
            ? theme.vars.palette.primary.main
            : theme.vars.palette.warning.main
        }`
      : 'auto',

  '& .MuiButton-startIcon': {
    margin: isRightPositioned ? 0 : theme.spacing(0, 2, 0, -1)
  }
}));

export const PeriodContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isToolbar'].includes(prop)
})<{
  isToolbar?: boolean;
}>(({ theme, isToolbar }) => ({
  display: 'flex',
  textAlign: 'left',
  flexDirection: isToolbar ? 'row' : 'column',
  gap: isToolbar ? theme.spacing(2) : 0,
  paddingLeft: theme.spacing(1)
}));

export const PeriodTitle = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  whiteSpace: 'nowrap',
  textAlign: 'center'
}));

export const PeriodSubtitle = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  textAlign: 'center'
}));

export const DateNavigationMenuContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(-2),
  paddingTop: theme.spacing(4),
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(4),
  backgroundColor: theme.palette.background.default
}));

export const TodayButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center'
});

export const PeriodChip = styled(Chip)(({ theme }) => ({
  height: '20px',
  border: '1px solid transparent',
  color: theme.palette.text.primary,
  margin: `0 ${theme.spacing(1)}`,
  '&.MuiChip-filled': {
    backgroundColor: theme.vars.palette.surface.containerLow,
    borderColor: theme.vars.palette.primary.main,
    color: theme.vars.palette.primary.main
  },
  '&.MuiChip-outlined': {
    borderColor: 'transparent'
  }
}));

export const StyledCaretIconBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'datePickerOpen'
})<BoxProps & { datePickerOpen?: boolean }>(({ datePickerOpen }) => ({
  display: 'inline-flex',
  transition: 'transform 0.3s ease',
  lineHeight: 0,
  transformOrigin: 'center',
  transform: datePickerOpen ? 'rotate(180deg)' : 'rotate(0deg)'
}));
